import React from 'react';
import ReactApexChart from 'react-apexcharts';

class CategoryRadar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          id: 'radar-chart',
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: [
            'ካህን',
            'ዲያቆን',
            'ተማሪ',
            'ምዕመን', 
          ],
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val}%`, // Use template literal for percentage sign
        },
      },
      series: [
        {
          name: 'Series 1',
          data: [20, 80, 100, 150],
          backgroundColor: [
            // Custom colors
            '#f44336',
            '#e91e63',
            '#9c27b0',
            '#673ab7',
            '#3f51b5',
            '#2196f3',
            '#03a9f4',
            '#00bcd4',
            '#009688',
            '#4caf50',
            '#8bc34a',
            '#cddc39',
          ],
          point: {
            radius: 5, // Adjust data point size as needed
          },
        },
      ],
    };
  }

  render() {
    return (
      <div className="radar-chart">
        <ReactApexChart options={this.state.options} series={this.state.series} type="radar" height={350} />
      </div>
    );
  }
}

export default CategoryRadar;
